import styled, { css } from 'styled-components'
import { DEVICES } from '@constants/global'
import { COLORS } from '@styles/colors'
import { FONTS } from '@styles/fonts'

export const PropertyPhoto = styled.div`
  max-height: 560px;
  display: flex;
  margin-bottom: 40px;

  @media ${DEVICES.mobile} {
    margin-bottom: 20px;
  }
`

export const PropertyPhotoInfo = styled.div`
  position: absolute;
  bottom: 10px;
  left: 10px;
  background: ${COLORS.navi};
  color: ${COLORS.white};
  font-family: ${FONTS.medium};
  border-radius: 2px;
  padding: 6px 10px;
  z-index: 99;
  align-items: center;
  display: flex;
  cursor: pointer;

  @media ${DEVICES.mobile} {
    display: flex;
  }
`

export const GalleryCount = styled.span`
  align-items: center;
  display: flex;

  svg {
    margin-right: 6px;
  }
`

export const MainPhoto = styled.div`
  width: calc(66.66666% - 6px);
  flex: 0 0 calc(66.66666% - 6px);
  margin-right: 6px;
  position: relative;
  border-radius: 0px 0px 100px 0px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
  }

  ${({ fullwidth }) =>
    fullwidth &&
    css`
      width: 100%;
      flex: 0 0 100%;
    `}

  @media ${DEVICES.mobile} {
    margin-right: 0;
    flex: 0 0 100%;
    border-radius: 0px 0px 48px 0px;
    width: 100%;
  }
`

export const Thumbnails = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  margin-left: 6px;
  width: calc(33.33333% - 6px);
  justify-content: space-between;
  flex: 0 0 calc(33.33333% - 6px);

  @media ${DEVICES.mobile} {
    display: none;
  }
`

export const Thumbnail = styled.div`
  background-size: cover;
  position: relative;
  height: calc((100% / 2) - 6px);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

  &:last-child {
    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(4, 28, 44, 0.5);
    }
  }
`

export const RemainingPhoto = styled.span`
  font-size: 54px;
  line-height: 62px;
  font-family: ${FONTS.bold};
  color: ${COLORS.white};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9;
`

export const KeyDetailsWrap = styled.div`
  margin-right: -25px;
  padding-top: 6px;

  > div > div {
    margin-right: 22px;
  }
`
